import React from 'react';
import { Avatar, ListItemAvatar } from '@material-ui/core';
import { TFunction } from 'react-i18next';
import { UserSearchResultExternal } from '@askporter/grieg-types';
import { SelectListItem } from '..';
import { FullUserRole } from '../../types';
import { fullName, getInitials } from '../../utils';

interface UserListItemProps {
  item: UserSearchResultExternal;
  t: TFunction<'translation'>;
  isSmallDevice: boolean;
  handleChange: () => void;
  isChecked: boolean;
}
const UserListItem: React.FC<UserListItemProps> = ({
  item,
  t,
  isSmallDevice,
  handleChange,
  isChecked,
}: UserListItemProps) => {
  return (
    <SelectListItem
      title={fullName(item?.givenName, item?.familyName)}
      details={FullUserRole[item?.roleSlug] ? t(`ns.${FullUserRole[item?.roleSlug]}`) : null}
      handleChange={handleChange}
      isChecked={isChecked}
      isSmallDevice={isSmallDevice}
      icon={
        <ListItemAvatar>
          <Avatar src={item?.profilePhoto?.filePath}>{getInitials(item?.givenName, item?.familyName)}</Avatar>
        </ListItemAvatar>
      }
    />
  );
};

export default UserListItem;
